const pastDealsDOTD = function() {
	let dotdSlider;
	
	const init = () => {
		if(!document.getElementById('noDeal')) setUpSlider();
	},
	setUpSlider = () => {
 		dotdSlider = new tns({
			container: document.getElementById('dotd-slider'),
			rewind: true,
			lazyload: true,
			prevButton: document.getElementById('leftArrowClick'),
			nextButton: document.getElementById('rightArrowClick'),
			speed: 500,
			items: 1, // number items on mobile
			nav: true,
			navPosition: "bottom"
		});
		
		//console.log("slider set up");
	};
	return{
		Init: init
	};
};

(function(){
	const pastDeals = new pastDealsDOTD();
	pastDeals.Init();
})()